import * as React from "react";
import classnames from "classnames";
import { Util } from "@grandvisionhq/common";
import { Heading } from "@grandvisionhq/elements";
import LazyPicture from "../../../LazyPicture/components/LazyPicture/LazyPicture.js";
const HighlightedContentItem = ({ image, link, title, text }) => {
  if (!image && !text && !title) {
    console.warn(`Cannot render USP: missing content`);
    return null;
  }
  const LinkElement = !!link ? "a" : "div";
  return /* @__PURE__ */ React.createElement(
    "section",
    {
      className: classnames("highlighted-content-item", {
        "highlighted-content-item__with-link": !!link
      })
    },
    /* @__PURE__ */ React.createElement(LinkElement, { className: "highlighted-content-item__link", href: link?.url || void 0 }, image && /* @__PURE__ */ React.createElement("div", { className: "highlighted-content-item__image" }, /* @__PURE__ */ React.createElement(LazyPicture, { image, showImageAsCover: true })), /* @__PURE__ */ React.createElement("div", { className: "highlighted-content-item__content" }, title && /* @__PURE__ */ React.createElement(Heading, { variant: "smallest", component: "h2", className: "highlighted-content-item__title" }, Util.truncateString(title, 50)), text && /* @__PURE__ */ React.createElement("p", { className: "highlighted-content-item__description" }, Util.truncateString(text, 200))))
  );
};
export {
  HighlightedContentItem as default
};
//# sourceMappingURL=HighlightedContentItem.js.map
